import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import lodash from "lodash";
import classnames from "classnames";

import PlanBox from "./PlanBox";
import PlanFilter from "./PlanFilter";

import {
  riskmedicalChangeBenefitPlanFilter,
  riskmedicalChangeBenefitPlan,
} from "actions/riskmedicalActions";
// import { updateBenefitsItem } from "actions/cartActions";
import { FormattedHTMLMessage } from "react-intl";
import messages from "components/messagesDescription";

// Required asterisk symbol for underwriting
const RequiredUWSymbol = ({ isHDFRequired }) => {
  const el = isHDFRequired === true ? "*" : "";

  return <sup className="error">{el}</sup>;
};

export const getFilteredPlans = benefit => {
  const { filters, filtersIncludeNone, plans, currentGroupName } = benefit;

  const isIncludeNoneVisible = filtersIncludeNone && filtersIncludeNone.length;
  const groupNameFilter =
    (filters && filters.length) || isIncludeNoneVisible ? currentGroupName : null;
  return groupNameFilter
    ? plans.filter(plan => plan.groupName === groupNameFilter)
    : plans;
};

// Required underwriting description if requiresUw value is set to true otherwise hide
const RequireUWDescription = ({ isHDFRequired }) => {
  const el =
    isHDFRequired === true ? (
      <small>
        <RequiredUWSymbol requiresUw={isHDFRequired} />
        <FormattedHTMLMessage {...messages.HDFRDescription} />
      </small>
    ) : (
      ""
    );

  return <p className="error">{el}</p>;
};

RequiredUWSymbol.propTypes = { isHDFRequired: PropTypes.bool };
RequireUWDescription.propTypes = { isHDFRequired: PropTypes.bool };

class PlanGroup extends Component {
  constructor(props) {
    super(props);

    this.planFilterDidChange = this.planFilterDidChange.bind(this);
    this.planDidChange = this.planDidChange.bind(this);
    this.planOptionDidChange = this.planOptionDidChange.bind(this);
  }

  planFilterDidChange(filter) {
    this.props.changePlanFilter(this.props.benefit.benefitId, filter);
  }

  planDidChange(plan, selectedOption) {
    // Check for group benefits
    if (plan.options) {
      //Check if Plan was already selected previously or not
      if (!selectedOption && plan.isSelected) {
        return;
      }

      //Set default selected option to EE
      if (!selectedOption) {
        // Try to find previously selected and available option
        let availableOptions = plan.options.filter(
          option => option.isAvailable && option.isSelected
        );

        // Try to find only available options
        if (!availableOptions || availableOptions.length === 0) {
          availableOptions = plan.options.filter(option => option.isAvailable);
        }

        // Select first available (and selected) option
        if (availableOptions && availableOptions.length) {
          selectedOption = availableOptions[0].type;
        }
      }

      if (selectedOption) {
        plan.options.forEach(option => (option.isSelected = option.type === selectedOption));
      }

      const selectedOptions = plan.options.filter(option => option.isSelected === true);

      plan.isSelected = selectedOptions && selectedOptions.length > 0;
    } else {
      // Otherwise handle non group benefits
      plan.isSelected = true;
    }

    this.props.changePlan(this.props.benefit, plan);
  }

  planOptionDidChange(plan, selectedOption) {
    // Check for group benefits
    if (plan.options) {
      plan.options.forEach(
        (option, index) =>
          (option.isSelected = selectedOption ? option.type === selectedOption : index === 0)
      );
    }

    if (plan.isSelected) {
      this.props.changePlan(this.props.benefit, plan);
    }
  }

  // componentWillReceiveProps(nextProps) {
  //   const { selectedPlan, balance, benefits } = nextProps;

  //   if (!lodash.isEmpty(selectedPlan) && this.props.balance === balance) {
  //     this.props.updateBenefitsItem(benefits, selectedPlan);
  //   }
  // }

  checkIfPlanIsAvailable = plan => {
    if (plan.options && Array.isArray(plan.options)) {
      const availableOptions = plan.options.filter(option => option.isAvailable === true);

      plan.isAvailable = availableOptions && availableOptions.length > 0;
    }
    return plan.isAvailable;
  };

  render() {
    const { benefit, currency } = this.props;
    const {
      filters,
      filtersIncludeNone,
      currentGroupName,
      showOptions,
      benefitId,
      selectionMode,
    } = benefit;

    const isIncludeNoneVisible = filtersIncludeNone && filtersIncludeNone.length;
    const filteredPlans = getFilteredPlans(benefit);

    const planBoxes = filteredPlans.map((plan, index) => (
      <PlanBox
        key={index}
        plan={plan}
        onChange={this.planDidChange}
        showOptions={showOptions}
        currency={currency}
        selectionMode={selectionMode}
        isAvailable = {this.checkIfPlanIsAvailable(plan)}
      />
    ));

    return (
      <div className="grid__wrapper">
        {isIncludeNoneVisible ? (
          <div className="grid__item grid__item--three">
            <div>
              <PlanFilter
                name={`${benefitId}-IncludeNone`}
                filters={filtersIncludeNone}
                currentFilter={currentGroupName}
                onChange={this.planFilterDidChange}
              />
            </div>
          </div>
        ) : null}
        {filters && filters.length ? (
          <div
            className={classnames("grid__item grid__item--three", {
              "hidden block--hidden": isIncludeNoneVisible,
            })}
          >
            <div>
              <PlanFilter
                name={benefitId}
                filters={filters}
                currentFilter={currentGroupName}
                onChange={this.planFilterDidChange}
              />
            </div>
          </div>
        ) : null}
        {planBoxes}
      </div>
    );
  }
}

PlanGroup.propTypes = {
  benefits: PropTypes.array,
  benefit: PropTypes.object.isRequired,
  changePlanFilter: PropTypes.func,
  changePlan: PropTypes.func,
  // updateBenefitsItem: PropTypes.func,
  // balance: PropTypes.number,
  selectedPlan: PropTypes.object,
  isOpen: PropTypes.bool,
  currency: PropTypes.string,
};

const mapStateToProps = store => ({
  benefits: store.riskmedical.benefits,
  selectedPlan: store.riskmedical.selectedPlan,
  // balance: store.cart.balance,
});

const mapDispatchToProps = dispatch => ({
  changePlanFilter: (benefitId, filter) =>
    dispatch(riskmedicalChangeBenefitPlanFilter(benefitId, filter)),
  changePlan: (benefit, filter) => dispatch(riskmedicalChangeBenefitPlan(benefit, filter)),
  // updateBenefitsItem: (itemId, itemPrice) =>
  //   dispatch(updateBenefitsItem(itemId, itemPrice)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PlanGroup);



// WEBPACK FOOTER //
// ./components/employee/shop/PlanGroup.js